import gql from 'graphql-tag';

export const CREATE_PERSON = gql`
	mutation createPersonMutation($input: CreatePersonInput!) {
		createPerson(input: $input) {
			id
			name
			email
			phoneNumber
			clients {
				id
			}
			locations {
				id
			}
		}
	}
`;
